module.exports = __webpack_public_path__ + "img/emoji_unhappy.svg";